import { render } from "./LiveChat.vue?vue&type=template&id=2a99d22e&scoped=true"
import script from "./LiveChat.vue?vue&type=script&lang=js"
export * from "./LiveChat.vue?vue&type=script&lang=js"

import "./LiveChat.vue?vue&type=style&index=0&id=2a99d22e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a99d22e"]])

export default __exports__